import React, { useState, FC } from 'react';
import { Link } from 'react-router-dom';
import { useInView } from 'react-hook-inview';
import { useTranslation } from 'react-i18next';
import Slider from 'react-slick';

import UseCaseCardIcon1 from '../../../images/solutions/usecase-card-1-icon.svg';
import UseCaseCardIcon2 from '../../../images/solutions/usecase-card-2-icon.svg';
import UseCaseCardIcon3 from '../../../images/solutions/usecase-card-3-icon.svg';
import UseCaseCardIcon4 from '../../../images/solutions/usecase-card-4-icon.svg';
import {
  UseCasesStyled,
  UseCasesDiagonalGrayTop,
  Title,
  CardsContainer,
  SliderContainer,
  PaginationPill,
  Card,
  CardIconContainer,
  CardTitle,
  Btn,
} from './style';

interface Props {}

const UseCases: FC<Props> = () => {
  const { t } = useTranslation();

  const [activeSlide, setActiveSlide] = useState(1);
  const [targetRef, isInViewport] = useInView({
    unobserveOnEnter: true,
  });

  const cardPath = [...Array(4)].map((_, index) => {
    return `/solutions/usecase/${index + 1}-${t(
      `SolutionUseCasesCard${index + 1}Title`
    )
      .toLowerCase()
      .replace(/ /g, '-')}`.toString();
  });

  const settings = {
    dots: false,
    arrows: true,
    infinite: false,
    autoplay: false,
    speed: 500,
    slidesToShow: 1.2,
    slidesToScroll: 1,
    beforeChange: (current: number, next: number) => {
      if (next > 2) {
        setActiveSlide(next + 1.2);
      } else {
        setActiveSlide(next + 1);
      }
    },
  };

  return (
    <UseCasesStyled id="usecases">
      <UseCasesDiagonalGrayTop />
      <div ref={targetRef} className="container">
        <Title
          className={
            isInViewport ? 'animate__animated animate__fadeInUp' : 'hide'
          }
        >
          {t('SolutionUseCasesTitle')}
        </Title>
        <CardsContainer>
          <div
            className={
              isInViewport
                ? 'animate__animated animate__fadeInUp animate__faster'
                : 'hide'
            }
          >
            <Card>
              <CardIconContainer>
                <img src={UseCaseCardIcon1} alt="icon" />
              </CardIconContainer>
              <CardTitle>{t('SolutionUseCasesCard1Title')}</CardTitle>
              <Link to={cardPath[0]}>
                <Btn>{t('SolutionUseCasesCardBtn')}</Btn>
              </Link>
            </Card>
          </div>
          <div
            className={
              isInViewport
                ? 'animate__animated animate__fadeInUp animate__faster animate__delay-1s'
                : 'hide'
            }
          >
            <Card>
              <CardIconContainer>
                <img src={UseCaseCardIcon2} alt="icon" />
              </CardIconContainer>
              <CardTitle>{t('SolutionUseCasesCard2Title')}</CardTitle>
              <Link to={cardPath[1]}>
                <Btn>{t('SolutionUseCasesCardBtn')}</Btn>
              </Link>
            </Card>
          </div>

          <div
            className={
              isInViewport
                ? 'animate__animated animate__fadeInUp animate__faster animate__delay-2s'
                : 'hide'
            }
          >
            <Card>
              <CardIconContainer>
                <img src={UseCaseCardIcon3} alt="icon" />
              </CardIconContainer>
              <CardTitle>{t('SolutionUseCasesCard3Title')}</CardTitle>
              <Link to={cardPath[2]}>
                <Btn>{t('SolutionUseCasesCardBtn')}</Btn>
              </Link>
            </Card>
          </div>
          <div
            className={
              isInViewport
                ? 'animate__animated animate__fadeInUp animate__faster animate__delay-3s'
                : 'hide'
            }
          >
            <Card>
              <CardIconContainer>
                <img src={UseCaseCardIcon4} alt="icon" />
              </CardIconContainer>
              <CardTitle>{t('SolutionUseCasesCard4Title')}</CardTitle>
              <Link to={cardPath[3]}>
                <Btn>{t('SolutionUseCasesCardBtn')}</Btn>
              </Link>
            </Card>
          </div>
        </CardsContainer>
      </div>
      <SliderContainer>
        <Slider {...settings}>
          <Card>
            <CardIconContainer>
              <img src={UseCaseCardIcon1} alt="icon" />
            </CardIconContainer>
            <CardTitle>{t('SolutionUseCasesCard1Title')}</CardTitle>
            <Link to={cardPath[0]}>
              <Btn>{t('SolutionUseCasesCardBtn')}</Btn>
            </Link>
          </Card>
          <Card>
            <CardIconContainer>
              <img src={UseCaseCardIcon2} alt="icon" />
            </CardIconContainer>
            <CardTitle>{t('SolutionUseCasesCard2Title')}</CardTitle>
            <Link to={cardPath[1]}>
              <Btn>{t('SolutionUseCasesCardBtn')}</Btn>
            </Link>
          </Card>
          <Card>
            <CardIconContainer>
              <img src={UseCaseCardIcon3} alt="icon" />
            </CardIconContainer>
            <CardTitle>{t('SolutionUseCasesCard3Title')}</CardTitle>
            <Link to={cardPath[2]}>
              <Btn>{t('SolutionUseCasesCardBtn')}</Btn>
            </Link>
          </Card>
          <Card>
            <CardIconContainer>
              <img src={UseCaseCardIcon4} alt="icon" />
            </CardIconContainer>
            <CardTitle>{t('SolutionUseCasesCard4Title')}</CardTitle>
            <Link to={cardPath[3]}>
              <Btn>{t('SolutionUseCasesCardBtn')}</Btn>
            </Link>
          </Card>
        </Slider>
        <PaginationPill>{activeSlide}/4</PaginationPill>
      </SliderContainer>
    </UseCasesStyled>
  );
};

export default UseCases;
